import { useAppSelector } from '@user/store/hooks'
import { selectTenantFeatureById } from '@user/store/tenantFeatures'
import { FEATURES } from '@sales-center/common/tenantFeatures'
import { useCallTrackingContext } from '../context'
import { useMemo } from 'react'

const fieldsOrderById = [8, 2, 1, 3, 6, 7, 9, 10, 11, 12, 5]
const callTrackingPhoneFieldId = 13

export function useData() {
  const [{ callTrackingDetails }] = useCallTrackingContext()
  const callTrackingState = useAppSelector((state) =>
    selectTenantFeatureById(state, FEATURES.CampaignTracking),
  )

  const infoLabel = useMemo(() => {
    if (callTrackingDetails.entityCallTrackingSystemFields?.length == 0) {
      return ''
    } else {
      return !callTrackingDetails.entityCallTrackingSystemFields?.find(
        (x) => x.fieldValue,
      )
        ? 'No tracked calls for this record.'
        : callTrackingDetails.isProcessing
        ? 'Call Tracking attributes may still be processing and will populate upon completion.'
        : ''
    }
  }, [callTrackingDetails])

  const preparedFields = useMemo(() => {
    const fields = {}

    callTrackingDetails.entityCallTrackingSystemFields?.forEach((field) => {
      fields[field.callTrackingSystemFieldId] = field
    })

    return fieldsOrderById.map((id) => fields[id])
  }, [callTrackingDetails.entityCallTrackingSystemFields])

  const callTrackingPhone = useMemo(
    () =>
      (callTrackingDetails?.entityCallTrackingSystemFields || [])
        .find(
          (field) =>
            `${field.callTrackingSystemFieldId}` ===
            `${callTrackingPhoneFieldId}`,
        )
        ?.fieldValue?.replace('+', ''),
    [callTrackingDetails.entityCallTrackingSystemFields],
  )

  return {
    infoLabel,
    callTrackingDetails: preparedFields.filter((field) => !!field) || [],
    callTrackingState,
    callTrackingPhone,
    inProcess: callTrackingDetails.isProcessing,
  }
}
